import React from 'react';

export const Input = ({
  value,
  onChange,
  placeholder,
  type = 'text',
  icon,
  error,
  label,
  fullWidth = true,
  disabled = false,
  className = '',
  ...props
}) => {
  return (
    <div style={{ width: fullWidth ? '100%' : 'auto', display: 'flex', flexDirection: 'column', gap: '6px' }}>
      {label && (
        <label
          style={{
            fontSize: '12px',
            fontWeight: '600',
            color: 'var(--text-secondary)',
            letterSpacing: '0.02em',
            textTransform: 'uppercase'
          }}
        >
          {label}
        </label>
      )}
      <div
        style={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          width: '100%'
        }}
      >
        {icon && (
          <span
            style={{
              position: 'absolute',
              left: '12px',
              color: 'var(--text-muted)',
              display: 'flex',
              alignItems: 'center',
              pointerEvents: 'none'
            }}
          >
            {icon}
          </span>
        )}
        <input
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          style={{
            width: '100%',
            padding: icon ? '10px 14px 10px 38px' : '10px 14px',
            backgroundColor: 'var(--surface-recessed)',
            boxShadow: 'var(--shadow-recessed-sm)',
            border: error ? '1px solid var(--color-danger)' : '1px solid var(--border-subtle)',
            borderRadius: 'var(--radius-md)',
            color: 'var(--text-primary)',
            fontSize: '14px',
            fontFamily: 'var(--font-body)',
            outline: 'none',
            transition: 'border-color 0.2s, box-shadow 0.2s',
            opacity: disabled ? 0.6 : 1
          }}
          className={`input-recessed ${className}`}
          {...props}
        />
      </div>
      {error && (
        <span style={{ fontSize: '12px', color: 'var(--color-danger)', marginTop: '2px' }}>
          {error}
        </span>
      )}
    </div>
  );
};

export const Textarea = ({
  value,
  onChange,
  placeholder,
  rows = 3,
  error,
  label,
  fullWidth = true,
  disabled = false,
  className = '',
  ...props
}) => {
  return (
    <div style={{ width: fullWidth ? '100%' : 'auto', display: 'flex', flexDirection: 'column', gap: '6px' }}>
      {label && (
        <label
          style={{
            fontSize: '12px',
            fontWeight: '600',
            color: 'var(--text-secondary)',
            letterSpacing: '0.02em',
            textTransform: 'uppercase'
          }}
        >
          {label}
        </label>
      )}
      <textarea
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        disabled={disabled}
        style={{
          width: '100%',
          padding: '10px 14px',
          backgroundColor: 'var(--surface-recessed)',
          boxShadow: 'var(--shadow-recessed-sm)',
          border: error ? '1px solid var(--color-danger)' : '1px solid var(--border-subtle)',
          borderRadius: 'var(--radius-md)',
          color: 'var(--text-primary)',
          fontSize: '14px',
          fontFamily: 'var(--font-body)',
          outline: 'none',
          resize: 'vertical',
          transition: 'border-color 0.2s, box-shadow 0.2s',
          opacity: disabled ? 0.6 : 1
        }}
        className={`input-recessed ${className}`}
        {...props}
      />
      {error && (
        <span style={{ fontSize: '12px', color: 'var(--color-danger)', marginTop: '2px' }}>
          {error}
        </span>
      )}
    </div>
  );
};
